export class ViewModelRetornoCobranca {
    dataReferencia: string;
    dataComplemento: string;
    modoLiquidacao: number;
    nomeModoLiquidacao: string;
    modulo: number;
    nomeModulo: string;
    contribuicao: number;
    plano: number;
    nmPlano: string;
    empresa: number;
    nmEmpresa: string;
    nmPessoa: string;
    dataVencimento: string;
    valorMulta: number;
    valorPrincipal: number;
    valorDesconto: number;
    valorEncargo: number;
    nossoNumero: string;
    codigoBarras: string;
    nrBoletoArquivo: string;
    nrCpf: string;
    dataPagamento: string;
    dataCancelamento: string;
    idCobranca: number;
    nmPessoaParticipante: string;
    nrCpfParticipante: string;
    idContratoEmp: number;
    numeroContrato: number;
    //public double ValorPessoa { get; set; }
    nrAnoComp: number;
    nrMesComp: number;
    dtCompetencia: string;

}